import { Button } from '@mui/material';
import { AxiosError } from 'axios';
import { MessageError, useWithMessage, WafBlockedError } from 'probonio-shared-ui/module/error';
import { all } from 'probonio-shared-ui/module/error/MessageError';
import React, { useCallback, useState } from 'react';

// Fakes an AxiosError with a given status, to exercise classifyError without a real request.
function fakeAxiosError(status: number): AxiosError {
  const error = new AxiosError(`Request failed with status code ${status}`);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (error as any).response = { status };
  return error;
}

export const ErrorSimulator = (): React.JSX.Element => {
  const withOtherDefaultMessage = useWithMessage(all('super error '));
  const withMessage = useWithMessage();
  const [fail, setFail] = useState(false);

  return (
    <>
      <Button
        variant="contained"
        onClick={useCallback(() => {
          void (async () => {
            throw new Error('An error');
          })().catch(withOtherDefaultMessage);
        }, [withOtherDefaultMessage])}
      >
        {'Catch with alternative default message'}
      </Button>

      <Button
        variant="contained"
        onClick={useCallback(() => {
          void Promise.reject(fakeAxiosError(403)).catch(withMessage);
        }, [withMessage])}
      >
        {'Throw 403 API error (reported as external)'}
      </Button>

      <Button
        variant="contained"
        onClick={useCallback(() => {
          void Promise.reject(fakeAxiosError(500)).catch(withMessage);
        }, [withMessage])}
      >
        {'Throw unexpected API error (500, reported)'}
      </Button>

      <Button
        variant="contained"
        onClick={useCallback(() => {
          void Promise.reject(new WafBlockedError('simulated')).catch(withMessage);
        }, [withMessage])}
      >
        {'Throw WAF blocked error (reported as external)'}
      </Button>

      <Button
        variant="contained"
        onClick={useCallback(() => {
          void (async () => {
            throw new Error('An error');
          })();
        }, [])}
      >
        {'Unhandled rejection'}
      </Button>

      <Button
        variant="contained"
        onClick={useCallback(() => {
          throw new Error('An error');
        }, [])}
      >
        {'Throw'}
      </Button>

      <Button
        variant="contained"
        onClick={useCallback(() => {
          throw new MessageError(new Error('An error'), 'super display message');
        }, [])}
      >
        {'Throw MessageError'}
      </Button>

      <Button
        variant="contained"
        onClick={useCallback(() => {
          setFail(true);
        }, [])}
      >
        {'Fail render'}
      </Button>

      {fail &&
        (() => {
          throw new Error('Render error');
        })()}
    </>
  );
};
